import FloatingVue, { Dropdown } from "floating-vue";
import "floating-vue/dist/style.css";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(FloatingVue, {
    /* options */
    themes: {
      'tooltip': {
        // defaultHtml: false in floating-vue is handled by html: false in directive or global
        html: true, // v-tooltip used false by default in code? No, usually true.
      },
    }
  });

  // Alias v-popover to Dropdown component from floating-vue
  nuxtApp.vueApp.component("v-popover", Dropdown);
});
